// @ts-strict-ignore
import { Material, Object3D } from 'three';
import { ArticleVO } from '@article/model/vo/article.vo';
import { ComplexProjectVO } from '@project/model/vo/project.vo';
import { MeshUtils } from '@3d-scene/common/util/mesh-utils';
import { MATERIAL_USAGE_COUNT } from '../../common/util/object-3d-utils';
import { IsThreeJsType } from '../../common/util/is-threejs-type';

export class ModelDataHolder {
  public article: ArticleVO;
  public modelData: ParsedArticleModelData | EmptyArticleModelData;

  constructor(article: ArticleVO, modelData: ParsedArticleModelData | EmptyArticleModelData) {
    this.article = article;
    this.modelData = modelData;
  }
}

export class CompositeModelDataHolder extends ModelDataHolder {
  private _project: ComplexProjectVO;

  public constructor(article: ArticleVO, project: ComplexProjectVO, modelData: any) {
    super(article, modelData);
    this._project = project;
  }

  public get complexProject(): ComplexProjectVO {
    return this._project;
  }
}

export class EmptyArticleModelData {
}

export class ParsedArticleModelData {

  public modelData: Object3D;
  public name: string;

  public constructor(container: Object3D = null, name: string = '') {
    this.modelData = container;
    this.name = name;
  }

  public cloneModelData(): Object3D {
    if (this.modelData) {
      const obj: Object3D = this.modelData.clone();
      this.modelData.children.forEach(child => {
        if (IsThreeJsType.mesh(child)) {
          if (MeshUtils.isConnection(child.name)) {
            child.material = (child.material as Material).clone();
            child.geometry = child.geometry.clone();
          } else {
            this.updateMaterialUsageCount(child.material as Material);
          }
        }
      });
      return obj;
    }
    return null;
  }

  private updateMaterialUsageCount(material: Material): void {
    if (material.hasOwnProperty(MATERIAL_USAGE_COUNT)) {
      material[MATERIAL_USAGE_COUNT]++;
    } else {
      material[MATERIAL_USAGE_COUNT] = 1;
    }
  }
}

export class ArticleModelDataHolder extends ModelDataHolder {
  private _type: string;
  private _sourceUrl: string;
  private _modelDataUsageCount = 0;
  private _modelDataHoldCount = 0;

  public constructor(article: ArticleVO, modelData: any, type: string, sourceUrl: string) {
    super(article, modelData);
    this._type = type;
    this._sourceUrl = sourceUrl;
  }

  public get isParsedArticleModelData(): boolean {
    return this.modelData instanceof ParsedArticleModelData;
  }

  public get isEmptyArticleModelData(): boolean {
    return this.modelData instanceof EmptyArticleModelData;
  }

  public get type(): string {
    return this._type;
  }

  public get sourceUrl(): string {
    return this._sourceUrl;
  }

  public get modelDataUsageCount(): number {
    return this._modelDataUsageCount;
  }

  public increaseModelDataUsageCount(): void {
    this._modelDataUsageCount++;
  }

  public get modelDataHoldCount(): number {
    return this._modelDataHoldCount;
  }

  public increaseModelDataHoldCount(): void {
    this._modelDataHoldCount++;
  }

  public clone(): ModelDataHolder {
    return new ArticleModelDataHolder(this.article, this.modelData, this.type, this.sourceUrl);
  }
}
